import { GridSize, InputProps } from "@mui/material";

import { DeliveryAddressModel } from "./DeliveryAddressModel";
import { DeviceCategoryModel } from "./DeviceCategoryModel";
import { DeviceContractModel } from "./DeviceContractModel";
import { DeviceRentalModel } from "./DeviceRentalModel";
import { DeviceTypeModel } from "./DeviceTypeModel";
import { ServiceModel } from "./ServiceModel";
import { UserModel } from "./UserModel";

export type DeviceModel = {
  id: number;
  deviceTypeId: number;
  deviceType?: DeviceTypeModel | null;
  deviceCategoryId: number;
  deviceCategory?: DeviceCategoryModel | null;
  serialNumber?: string | null;
  apNumber?: string | null;
  state?: string | null;
  warehouseCode?: string | null;
  kszlaSzam?: string | null;
  comment?: string | null;
  deviceRentalId?: number | null;
  deviceRental?: DeviceRentalModel | null;
  serviceCode?: string | null;
  service?: ServiceModel | null;
  updatedBy?: string | null;
  updatedByUser?: UserModel | null;
  createdAt: string;
  updatedAt: string;
  //extended/joined values from API response
  partnerCode?: number | null;
  deliveryAddressCode?: number | null;
  deliveryAddress?: DeliveryAddressModel | null;
  deviceContract?: DeviceContractModel | null;
  isReplacementNeed?: boolean | null;
  isTakenBack?: boolean | null;
  //extended values
  outDate?: string | null;
  inDate?: string | null;
  partner?: string | null;
  partnerAddressName?: string | null;
  partnerFullAddress?: string | null;
  deviceTypeName?: string | null;
  deviceCategoryName?: string | null;
  statusName?: string | null;
  fee?: number | null;
};

export type DeviceTableKey = {
  label: string;
  key: string;
  align?: "inherit" | "left" | "right" | "center" | "justify" | null;
};

export type DeviceGridKey = {
  label: string;
  key: string;
  inputHidden?: true | null;
  inputDisabled?: true | null;
  md?: GridSize | null;
  sm?: GridSize | null;
  xs?: GridSize | null;
  align?: "inherit" | "left" | "right" | "center" | "justify" | null;
  mandatory?: true | null;
  inputProps?: InputProps;
  customInput?: (props: Record<string, unknown>) => JSX.Element;
};

export const tableKeys: DeviceTableKey[] = [
  { label: "Ügyfél", key: "partner" },
  { label: "Telephely neve", key: "partnerAddressName" },
  { label: "Telephely címe", key: "partnerFullAddress" },
  { label: "Eszköz kategóriája", key: "deviceCategoryName" },
  { label: "Eszköz típusa", key: "deviceTypeName" },
  { label: "Eszköz gyáriszáma", key: "serialNumber" },
  { label: "Kihelyezés dátuma", key: "outDate" },
  { label: "Visszavétel dátuma", key: "inDate" },
  { label: "Havi díj", key: "fee" },
  { label: "Státusz", key: "statusName" },
];

export const gridKeys: DeviceGridKey[] = [
  { label: "AP szám", key: "apNumber" },
  { label: "Visszavétel dátuma", key: "inDate" },
  { label: "Havi díj", key: "fee" },
];

export const returnDeviceGridKeys: DeviceGridKey[] = [
  { label: "Partner neve", key: "partner", inputDisabled: true },
  { label: "Telephely megnevezése", key: "partnerAddressName", inputDisabled: true },
  { label: "Telephely címe", key: "partnerFullAddress", inputDisabled: true },
  { label: "Eszköz kategóriája", key: "deviceCategoryName", inputDisabled: true },
  { label: "Eszköz típusa", key: "deviceTypeName", inputDisabled: true },
];

export const getDeviceStateName: (state: string) => string = (state: string): string => {
  switch (state) {
    case "K":
      return "Kihelyezett";
    case "S":
      return "Szervízben";
    case "X":
      return "Selejt";
    case "U":
      return "Raktáron";
    case "O":
      return "Összerendelt";
    case "V":
      return "Visszavett";
    default:
      return "Nincs megadva";
  }
};

export type DeviceFilter = {
  name: string;
  serial: string;
  state: string;
  category: string;
  type: string;
};

export type DeviceState = {
  key: string;
  desc: string;
};
